import { LoadingIndicator } from 'components/LoadingIndicator';
import { useCallback, useEffect, useState } from 'react';

const IframePage: React.FC<{
  title: string;
  src: string;
}> = ({ title, src }) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
  }, [src]);

  const handleOnLoad = useCallback(() => setLoading(false), []);

  return (
    <>
      {loading && <LoadingIndicator />}
      <iframe
        src={src}
        title={title}
        frameBorder='0'
        width='100%'
        height='100%'
        allowFullScreen={true}
        onLoad={handleOnLoad}
      />
    </>
  );
};

export const FAQ: React.FC = () => (
  <IframePage
    title='FAQ'
    src='https://docs.google.com/presentation/d/e/2PACX-1vTRZpETPqymLHpoEExUYNxtJj9ST4H3mu2GBLNH5JLXz2a4488dy1aTcRc4_9v2J5QISr_v_fYQVVHV/pubembed?start=false&loop=false&delayms=3000'
  />
);
